const getState = (state: AppState) => state.authorization;

export const authorizationSelector = {
  getState,
};
